export default "__VITE_ASSET__30pxCl5W__"